import * as React from "react"
import type { SVGProps } from "react"
const SvgAd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7.5 13.93v.75a.73.73 0 0 1-.75.75.73.73 0 0 1-.75-.75v-4.25q0-.42.29-.71A1 1 0 0 1 7 9.43h3q.42 0 .71.29.3.29.29.71v4.25a.73.73 0 0 1-.75.75.73.73 0 0 1-.75-.75v-.75zm2-1.5h-2v-1.5h2zm7 3h-2.75a.73.73 0 0 1-.75-.75v-4.5a.73.73 0 0 1 .75-.75h2.75q.6 0 1.05.45t.45 1.05v3q0 .6-.45 1.05t-1.05.45m0-1.5h-2v-3h2z"
    />
    <path
      fillRule="evenodd"
      d="M4 20.43q-.82 0-1.41-.59A2 2 0 0 1 2 18.43v-12q0-.82.59-1.41A2 2 0 0 1 4 4.43h16q.83 0 1.41.59.6.59.59 1.41v12q0 .82-.59 1.41a2 2 0 0 1-1.41.59zm0-14v12h16v-12z"
    />
  </svg>
)
export default SvgAd
